import React, { Component } from "react";
import $ from "jquery";

import Loader from "../components/loader";

import { renderErrorMessage } from "../helper/user_helper";
import Category from "../components/categories/category";
// import QuestionLine from "../components/questions/question_line";
import ListQuestion from "../components/list/interface/list_question";
import { getCategoryQuestions } from "../helper/category_helper";

class CategoryPage extends Component {
  state = {
    categoryId: null,
    category: null,
    errors: "",
    loaded: false,
    questions: [],
    current_page: 1,
    total_pages: 1,
    can_load_more: true
  };

  constructor(props) {
    super(props);

    this.state = {
      categoryId: props.match.params.id,
      errors: "",
      loaded: false,
      questions: [],
      current_page: 1,
      total_pages: 1,
      can_load_more: true
    };
  }

  componentDidMount() {
    this.getQuestions(this.state.current_page);
    this.refContainer.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    if (this.questionsCall) {
      this.questionsCall.cancel();
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.renderCategoryTitle()}
        {this.renderQuestionsListPage()}
      </React.Fragment>
    );
  }

  handleScroll() {
    if (this.state.can_load_more === false) {
      // Checking if we are not already loading more data
      return;
    }
    if (this.state.current_page >= this.state.total_pages) {
      // We don't check anything if questions doesn't have other questions
      return;
    }
    if (
      $("#questions").scrollTop() + $("#questions").innerHeight() >=
      $("#questions")[0].scrollHeight
    ) {
      // Load More questions
      this.setState({ can_load_more: false });
      const current_page = this.state.current_page + 1;
      this.setState({ current_page });
      this.getQuestions(this.state.current_page);
    } else {
      // Nothing
    }
  }

  renderCategoryTitle() {
    if (this.state.category == null) {
      return <div />;
    }
    return <Category category={this.state.category} link={false} />;
  }

  renderQuestionsListPage() {
    // const self = this;
    var questions = this.state.questions.map(function(question) {
      return (
        <div className="question_answer_v2 pb-3 pt-3" key={question.id}>
          <ListQuestion
            question={question}
            showAnswer={true}
            row={true}
            link={true}
          />
        </div>
        // <QuestionLine key={question.id} question={question} showAnswer={true} />
      );
    });
    return (
      <div
        id="questions"
        className="center list_questions list allow_scroll"
        ref={ref => {
          this.refContainer = ref;
        }}
      >
        <Loader loaded={this.state.loaded} />

        {renderErrorMessage(this.state.errors)}
        <div className="max_width_500">{questions}</div>
      </div>
    );
  }

  getQuestions(page) {
    const self = this;
    this.questionsCall = getCategoryQuestions(this.state.categoryId, page);
    this.questionsCall.promise.then(answer => {
      const questions = self.state.questions.concat(answer.questions);
      const category = answer.category;
      const total_pages = answer.total_pages;
      const loaded = answer.loaded;
      const errors = answer.errors;
      const can_load_more = true;
      self.setState({
        questions,
        category,
        total_pages,
        loaded,
        errors,
        can_load_more
      });
    });
  }
}

export default CategoryPage;



// WEBPACK FOOTER //
// ./src/pages/category.jsx